<template>
  <div
    class="mobile-toolbar"
    :class="{
      'is-retract': !isExpanded,
      'hide-toolbar': !showMobilToolBar,
    }"
  >
    <transition v-if="isWhiteBoard" name="fade">
      <div
        v-if="isExpanded"
        ref="expandedToolbar"
        class="toolbar-main expanded-toolbar-main"
      >
        <button
          v-for="tool in tools"
          :key="tool.key"
          :class="['tool-btn', { active: selectedTool === tool.key }]"
          @touchstart="handleToolClick(tool)"
          :aria-label="tool.label"
          tabindex="0"
        >
          <img :src="tool.icon" :alt="tool.label" />
          <!-- 子菜单 -->
          <template v-if="tool.menuComponent">
            <div
              class="menu-wrapper"
              v-show="showMenu && currentMenuComponent === tool.menuComponent"
              @touchstart.stop
            >
              <component
                :is="tool.menuComponent"
                class="menu-wrap"
                :ref="tool.menuComponent"
              />
            </div>
          </template>
        </button>
      </div>
      <div v-else class="toolbar-main">
        <button
          class="tool-btn active"
          :aria-label="selectedToolLabel"
          tabindex="0"
          @touchstart="handleExpand"
        >
          <img :src="selectedToolIcon" :alt="selectedToolLabel" />
        </button>
      </div>
    </transition>
    <div class="toolbar-bottom">
      <button
        v-show="isHorizontal"
        @touchstart="toggleLandscapeState"
        class="landscape-btn"
        aria-label="切换横竖屏"
        tabindex="0"
      >
        <img
          src="../../assets/images/landscape.png"
          alt="切换横竖屏"
        />
      </button>
      <button
        v-show="isHorizontal"
        @touchstart="toggleAudioState"
        class="audio-btn"
        aria-label="音频设备"
        tabindex="0"
      >
        <img
          v-if="isAudioOpen"
          src="../../assets/images/microphone.png"
          alt="音频设备"
        />
        <img
          v-else
          src="../../assets/images/microphone-off.png"
          alt="音频设备"
        />
      </button>
      <button
        v-if="isExpanded && isWhiteBoard"
        class="close-btn"
        aria-label="收起工具栏"
        tabindex="0"
        @touchstart="handleClose"
      >
        <img src="../../assets/images/close.png" alt="收起工具栏" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PenMenu from "../components/PenMenu.vue";
import EraserMenu from "../components/EraserMenu.vue";

export default {
  name: "MobileToolbar",
  components: {
    PenMenu,
    EraserMenu,
  },
  props: {
    isAudioOpen: {
      type: Boolean,
      default: true,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    isWhiteBoard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: true,
      selectedTool: "pen",
      showMenu: false,
      currentMenuComponent: null,
      tools: [
        {
          key: "mouse",
          label: "鼠标",
          icon: require("../../assets/images/mouse.png"),
        },
        {
          key: "pen",
          label: "画笔",
          icon: require("../../assets/images/pen.png"),
          menuComponent: "PenMenu",
        },
        {
          key: "eraser",
          label: "橡皮擦",
          icon: require("../../assets/images/eraser.png"),
          menuComponent: "EraserMenu",
        },
      ],
    };
  },
  watch: {
    isWhiteBoard: {
      handler(newval) {
        if (newval) {
          this.isExpanded = true;
          this.selectedTool = "pen";
          this.showMenu = false;
          this.currentMenuComponent = null;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // 添加全局点击事件监听
    window.addEventListener("touchstart", this.handleGlobalClick);
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    window.removeEventListener("touchstart", this.handleGlobalClick);
  },
  methods: {
    setCurrentMenuComponentValue(menuComponent) {
      if (menuComponent === "EraserMenu") {
        // if (this.role !== 3) {
        // 学生端不展示橡皮子菜单
        this.currentMenuComponent = null;
        this.showMenu = false;
        // }
      } else {
        this.currentMenuComponent = menuComponent;
      }
    },
    toggleAudioState() {
      this.$jsToFlutter("micBtnClick", {});
    },
    toggleLandscapeState() {
      this.$jsToFlutter("landscapeBtnClick", {});
    },
    // 处理全局点击事件
    handleGlobalClick(event) {
      this.$emit('on-log',`handleGlobalClick show:${this.showMenu} target:${event.target}`)
      // 如果子菜单没有显示，不需要处理
      if (!this.showMenu) return;

      // 获取工具栏元素和当前子菜单元素
      const toolbarEl = this.$refs?.expandedToolbar;
      const currentMenuEl = this.currentMenuComponent
        ? this.$refs[this.currentMenuComponent]?.[0]?.$el
        : null;

      // 检查点击是否发生在展开的工具栏主区域或当前打开的菜单内部
      const isClickInExpandedToolbar = toolbarEl?.contains(event.target);
      const isClickInSubmenu = currentMenuEl?.contains(event.target);

      // 如果点击发生在展开的工具栏主区域或子菜单内部，不处理
      if (isClickInExpandedToolbar || isClickInSubmenu) {
        return;
      }

      // 其他所有情况都关闭子菜单
      this.showMenu = false;
      this.currentMenuComponent = null;
    },
    handleToolClick(tool) {
      const { key, menuComponent } = tool;
      this.$emit('on-log',`handleToolClick key:${key} menuComponent:${menuComponent} isCurrentTool:${this.selectedTool === key}`)
      if (menuComponent) {
        // 如果点击的是当前工具，则切换菜单显示状态
        if (this.selectedTool === key) {
          this.showMenu = !this.showMenu;
          if (this.showMenu) {
            this.setCurrentMenuComponentValue(menuComponent);
          } else {
            this.currentMenuComponent = null;
          }
        } else {
          // 如果点击的是新工具，则显示新工具的菜单
          this.showMenu = !!menuComponent;
          this.setCurrentMenuComponentValue(menuComponent);
        }
        this.selectedTool = key;

        if (this.$refs[menuComponent]?.[0]?.handleStyleChange) {
          this.$refs[menuComponent][0].handleStyleChange();
        }
      } else {
        if (this.selectedTool === key) return;
        // 没有子菜单
        this.selectedTool = key;
        this.showMenu = false;
        this.currentMenuComponent = null;

        // 根据工具类型设置白板工具
        switch (key) {
          case "mouse":
            this.whiteBoardService.setMouseTool();
            break;
        }
      }
    },
    handleClose() {
      this.$emit('on-log',`handleClose`)
      this.isExpanded = false;
      this.showMenu = false;
      this.currentMenuComponent = null;
    },
    handleExpand() {
      this.isExpanded = true;
    },
  },
  computed: {
    selectedToolLabel() {
      return this.tools.find((t) => t.key === this.selectedTool)?.label || "";
    },
    selectedToolIcon() {
      return this.tools.find((t) => t.key === this.selectedTool)?.icon || "";
    },
    ...mapState("live", ["whiteBoardService"]),
    ...mapState("whiteBoard", ["showMobilToolBar"]),
  },
};
</script>

<style lang="scss" scoped>
.mobile-toolbar {
  position: absolute;
  right: 12px;
  bottom: 20px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  &.is-retract {
    flex-direction: row-reverse;
    .toolbar-main {
      margin-bottom: 0;
      .tool-btn {
        margin-left: 10px;
      }
    }
  }
  &.hide-toolbar {
    .toolbar-main,
    .close-btn {
      display: none !important;
    }
  }
  .toolbar-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 12px;
    .tool-btn {
      position: relative;
      width: 40px;
      height: 40px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #e5e6eb;
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        background: #bedaff;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .toolbar-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    .audio-btn,
    .landscape-btn,
    .close-btn {
      width: 40px;
      height: 40px;
      background: #C9CDD4;
      box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #C9CDD4;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .audio-btn {
      background: #ffffff;
    }
    .landscape-btn {
      margin-left: 0;
      background: #ffffff;
    }
  }

  // 子菜单样式
  ::v-deep .menu-wrapper {
    position: absolute;
    right: 50px;
    z-index: 21;
    .section-title {
      text-align: left;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
